"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var button_1 = require("../../../button");
var form_1 = require("../../../form");
var style_1 = require("../style");
var LoginForm = function (_a) {
    var onSuccess = _a.onSuccess, onSubmit = _a.onSubmit;
    var _b = react_1.useState({
        email: '',
        password: ''
    }), fields = _b[0], setFields = _b[1];
    var _c = react_1.useState(false), error = _c[0], setError = _c[1];
    var handleSubmit = function (event) {
        event.preventDefault();
        onSubmit(fields)
            .then(function (response) { return onSuccess(response); })["catch"](function (error) {
            setError(true);
        });
    };
    return (react_1["default"].createElement("form", { onSubmit: handleSubmit },
        error && react_1["default"].createElement(style_1.Error, { role: "alert" }, "Incorrect e-mail or password."),
        react_1["default"].createElement(form_1.Wrapper, { label: "E-mail", name: "email" },
            react_1["default"].createElement(form_1.Input, { type: "email", name: "email", onChange: function (field) {
                    var _a;
                    return setFields(__assign(__assign({}, fields), (_a = {}, _a[field.name] = field.value, _a)));
                } })),
        react_1["default"].createElement(form_1.Wrapper, { label: "Password", name: "password" },
            react_1["default"].createElement(form_1.Input, { type: "password", name: "password", onChange: function (field) {
                    var _a;
                    return setFields(__assign(__assign({}, fields), (_a = {}, _a[field.name] = field.value, _a)));
                } })),
        react_1["default"].createElement(button_1.Submit, { label: "Login" })));
};
exports["default"] = LoginForm;
